/**
 * @author Ivan Toth.
 */
var incentive = { incentive: '=' };
var DetailTableComplClSamplingController = (function () {
    function DetailTableComplClSamplingController(topic, env, Dialog, $scope, socket) {
        var _this = this;
        this.topic = topic;
        this.env = env;
        this.Dialog = Dialog;
        this.$scope = $scope;
        this.socket = socket;
        this.tableName = 'Sampling Checklist';
        this.isSamplingFinished = false;
        this.displayRadioButton = true;
        this.lock = false;
        this.isSamplingValid = true;
        this.visible = true;
        // Listener for any 10k updates
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            // If the topic has been updated from the server...check if this component is part of 
            // what was changed
            _this.setSamplingCompl();
            if (data.indexOf(_this.comp) > -1) {
                // If so, set edit status accordingly...
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    ;
    DetailTableComplClSamplingController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableComplClSamplingController.prototype.setSamplingCompl = function () {
        this.samplingCompl = !(angular.isUndefined(this.incentive)) ? 'complcl_sampling_' + this.incentive : 'complcl_sampling';
        this.comp = this.samplingCompl;
        this.updateArray = [this.samplingCompl, 'sampling'];
    };
    DetailTableComplClSamplingController.prototype.$onInit = function () {
        this.setSamplingCompl();
        // Check whether should be editable or not
        this.edit = this.topic.getEditComponent(this.comp);
    };
    /**
     * Note: event here may or may not be parsed....only for use with Failed and Passed buttons
     *
     * @param {string} action
     * @param {ng.IAngularEvent} event
     * @memberof DetailTableComplClSamplingController
     */
    DetailTableComplClSamplingController.prototype.changeEditMode = function (action, event) {
        var _this = this;
        if (action === 'save') {
            // Set the status of this component to Updating...
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                // Prepare data to be saved
                var updateObject = {
                    data: {},
                    id: this.topic.topic._id,
                    type: [this.samplingCompl]
                };
                updateObject.data[this.samplingCompl] = {
                    add: true,
                    data: this.topic.temp[this.samplingCompl]
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true); // Send it to be saved
                this.edit.editMode = this.topic.cancelEdit(this.comp); // Turn edit off
            }
        }
        else if (action === 'edit') {
            this.refreshSamplingValidity();
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp); //added back to reset the updated fields
        }
        else if (action === 'Passed' || action === 'Failed') {
            //Prepare to ask question...based on event
            var items = {
                icon: 'QUESTION',
                message: 'Should you choose to continue, the results will become locked and uneditable. &nbsp;Continue?',
                title: action
            };
            //Warn
            this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
                if (dResult.confirm) {
                    // Create similar package to one from activate... this time contains the action will be Fail/Pass
                    // need to update 'sampling' only but ensure this component is updated, too to put out of edit mode...and lock
                    // Create a package according to Activate or Deactivate
                    var sampPackage = {};
                    sampPackage.action = action; // Failed or Passed 
                    var currentStatus = _this.topic.topic.sampling[_this.incentive] ?
                        _this.topic.topic.sampling[_this.incentive].samplingStatus : _this.topic.topic.sampling.samplingStatus;
                    sampPackage.incentiveType = [_this.incentive];
                    switch (currentStatus) {
                        case 'In Progress':
                        case 'Pending BP Compliance Review':
                            sampPackage.status = action;
                            break;
                        case 'Manually sampled - In Progress':
                            sampPackage.status = 'Manually sampled - ' + action;
                            break;
                        default: break;
                    }
                    sampPackage.incentiveStatus = _this.incentive;
                    // Creat object to send to server
                    var data = {
                        opp: _this.topic.getId(_this.topic.topic._id),
                        sampPack: sampPackage
                    };
                    // Set the checklist status to updating...
                    if (_this.topic.updatePartialSocketStatus([_this.comp], 'Updating')) {
                        // But call the sampling update instead of the 10k... this will do both
                        _this.socket.emit('module', {
                            module: {
                                application: 'dmt',
                                function: 'updateSampling',
                                //script: '/queue/queue',
                                script: '/detail/sampling/sampling',
                                data: data,
                                user: _this.env.user,
                                //email: this.env.user.email,
                                bID: _this.topic.topicBrowserID //Need this to be able to utilise the update.partial socket
                            }
                        });
                        _this.edit.editMode = _this.topic.cancelEdit(_this.comp);
                        _this.edit.editable = false;
                    }
                }
            });
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailTableComplClSamplingController.prototype.refreshSamplingValidity = function () {
        var tt = 'temp';
        if (angular.isUndefined(this.topic.temp[this.samplingCompl])) {
            tt = 'topic';
        }
        this.missingSampCLQs = ''; //wipe
        this.isSamplingValid = true; //Assume all good
        for (var i = 0; i < this.topic[tt][this.samplingCompl].check_list.length; i++) {
            if (this.topic[tt][this.samplingCompl].check_list[i].answer === '' && typeof this.topic[tt][this.samplingCompl].check_list[i].head === 'undefined') {
                if (this.missingSampCLQs.length > 0) {
                    this.missingSampCLQs += ', ';
                }
                this.missingSampCLQs += (i + 1);
                this.isSamplingValid = false;
            }
        }
        if (this.missingSampCLQs.length > 0) {
            this.missingSampCLQs = 'Sampling completion not possible until the following questions are answered: ' + this.missingSampCLQs;
        }
    };
    DetailTableComplClSamplingController.prototype.itemChanged = function (line) {
        var tempValCheck = true;
        for (var i = 0; i < this.topic.temp[this.samplingCompl].check_list.length; i++) {
            if (this.topic.temp[this.samplingCompl].check_list[i].answer === '' && typeof this.topic.temp[this.samplingCompl].check_list[i].head === 'undefined') {
                tempValCheck = false;
            }
        }
        this.isSamplingValid = tempValCheck;
    };
    DetailTableComplClSamplingController.$inject = ['topic', 'env', 'Dialog', '$scope', 'socket'];
    return DetailTableComplClSamplingController;
}());
var DetailTableComplClSamplingComponent = (function () {
    function DetailTableComplClSamplingComponent() {
        this.templateUrl = 'detail-table-complcl.html';
        this.controllerAs = 'vm';
        this.bindings = incentive;
        this.controller = DetailTableComplClSamplingController;
    }
    return DetailTableComplClSamplingComponent;
}());
angular
    .module('application')
    .component('detailTableComplClSampling', new DetailTableComplClSamplingComponent());

//# sourceMappingURL=detail.table.complcl.sampling.component.js.map
